import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
// import Alert from "react-bootstrap/Alert";
import "../../styles/open-pages/lead-management.css";
import WelcomeUser from "../../components/Open-pages/user/WelcomeUser";
import HelmetWrapper from "../../HelmetWrapper";
import LeadLandingCommon from "../../components/lead-management/common/LeadLandingCommon";
import Notifications from "../../components/push-notifications/Notifications";

const LeadManagementOpen = () => {
  const navigate = useNavigate();

  // const isNotificationDenied = useSelector(
  //   (state) => state.notification.permission
  // );

  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access");
    }
  }, [pageState]);

  // const location = useLocation();
  // const { decryptedText: userInfoData, isCustom } = location.state || {};
  // useEffect(() => {
  //   if (!userInfoData) {
  //     navigate("/open-access");
  //   }
  // }, [userInfoData]);

  return (
    <HelmetWrapper title="Lead Management System">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {userInfoData && !isIOS() && <Notifications authData={userInfoData} />}

        <Row>
          <Col>
            <WelcomeUser userName={userInfoData?.name} />
            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </Col>
        </Row>

        <LeadLandingCommon userInfoData={userInfoData} isCustom={isCustom} />

        <br />
        <br />
      </Container>
    </HelmetWrapper>
  );
};

export default LeadManagementOpen;
